import { render, staticRenderFns } from "./NormalOrDialog.vue?vue&type=template&id=d42b7e30"
import script from "./NormalOrDialog.vue?vue&type=script&lang=js"
export * from "./NormalOrDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports